import { Grid } from '@mui/material';
import { memo, useCallback } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DatePicker } from '@mui/lab';
import { ItalianForm } from 'shell/view-models/italian-form';
import Italian from '../../shared/italian';

interface IncorporationCertificateProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  nothingRequired?: boolean;
}

const IncorporationCertificateComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  nothingRequired = false,
}: IncorporationCertificateProps): React.ReactElement => {
  const onChangeItalian = useCallback(
    (key, value) => {
      onChange('italian', {
        ...(values || {}).italian,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onChangesItalian = useCallback(
    (valuesNew) => {
      onChange('italian', {
        ...(values || {}).italian,
        ...valuesNew,
      });
    },
    [values, onChange]
  );

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={4}>
        <DatePicker
          label={`Data certificato costituzione ${nothingRequired ? '' : '*'}`}
          aria-label="certificato costituzione"
          value={values?.dateIncorporationCertificate || null}
          onChange={(date) => {
            onChange('dateIncorporationCertificate', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateIncorporationCertificate"
              fullWidth
              helperText={errors?.dateIncorporationCertificate}
              error={
                touched?.dateIncorporationCertificate &&
                Boolean(errors?.dateIncorporationCertificate)
              }
            />
          )}
        />
      </Grid>
      <Italian
        disabledComponent={disabled}
        values={values?.italian}
        onChange={onChangeItalian}
        onChanges={onChangesItalian}
        errors={errors?.italian as FormikErrors<ItalianForm>}
        touched={touched?.italian as unknown as FormikTouched<ItalianForm>}
        labelMunicipality="Comune certificato costituzione"
        labelProvince="Provincia certificato costituzione"
        required={!nothingRequired}
        fromDate={values?.dateIncorporationCertificate || null}
      />
    </Grid>
  );
};

IncorporationCertificateComponent.displayName = 'Form Incorporation Certificate component';

const IncorporationCertificate = memo(IncorporationCertificateComponent);

export default IncorporationCertificate;
